import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchLocalizationsData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api";
import { ILocalizationsData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm.models";

const useFetchLocalizationsData = (
  companyId: string,
  structureId: string | undefined,
  query?: string
) => {
  const normalizedQuery = query?.trim();
  const filters = normalizedQuery
    ? `(${normalizedQuery
        .split(/\s+/)
        .map((word) => `value=like=*${word}*`)
        .join(";")})`
    : null;

  return useInfiniteQuery<ILocalizationsData, Error>({
    queryKey: ["fetch-localization-data", companyId, structureId, query],
    queryFn: async ({ pageParam, signal }) =>
      fetchLocalizationsData(companyId, structureId!, {
        signal,
        cursor: pageParam as string | undefined,
        filters,
      }),
    enabled: !!companyId && !!structureId,
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    placeholderData: (previousData) =>
      previousData ?? { pages: [], pageParams: [] },
  });
};

export default useFetchLocalizationsData;
